import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Login Method
export const chatLogin = (data) => api.create(url.LOGIN, data);

// ForgetPwd
export const forgotPassword = data => api.create(url.PASSWORD_FORGET, data);
export const ResetPassword = data => api.create(url.RESET_PASSWORD, data);

//update and fetch admin profile
export const editUser = (id, data) => api.put(`${url.EDIT_USER}/${id}`, data);
export const fetchProfile = (data) => api.get(url.FETCH_PROFILE, data)

//users
export const updateUserStatus = (data) =>
    api.put(`${url.UPDATE_USER_STATUS}/${data.id}`, { status: data.status });
export const deleteUser = (data) => api.delete(url.DELETE_USER, data);
export const bulkDeleteUser = (data) => api.create(url.BULK_DELETE_USER, data);
export const getUserWithFilter = (data) => api.get(url.GET_USER_WITH_FILTER, data);


